"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoanAmount;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _reactRedux = require("react-redux");
var _actions = require("../store/actions");
var _usersession = require("usersession");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
    06/14/2020 - Suhas

    This is a slider to show Purchase Price in Rate-Quote slider.

    Following are the changes done from its original implementation:
    - DownPayment is seperated out from PurchasePrice
    
*/

// import { useRatesContext } from "../context/ratesContext";

const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop, {
  behavior: "smooth"
});
// General scroll to element function

function LoanAmount() {
  // const { state, PurchasePriceUpdate, ShowButtons } = useRatesContext();
  const [purchasePrice, setPurchasePrice] = (0, _react.useState)("");
  const dispatch = (0, _reactRedux.useDispatch)();
  const purchasePriceRedux = (0, _reactRedux.useSelector)(state => state.nameReducer.purchasePrice);
  // const purchasePriceRedux = state.purchasePrice;

  const userSession = new _usersession.UserSession();
  const myRefPurchase = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    //This function scroll the slider into view

    // REACT-69: updated condition when NOT to scroll
    !localStorage.getItem("doNotScroll") && scrollToRef(myRefPurchase);
  }, []);
  (0, _react.useEffect)(() => {
    dispatch((0, _actions.ShowButtons)(true));
    // ShowButtons(true);
    document.getElementById("next-button").disabled = false;
    setPurchasePrice(purchasePriceRedux);
    userSession.setPurchasePrice(purchasePriceRedux);
    if (purchasePrice.length > 0) {
      dispatch((0, _actions.ShowButtons)(true));
      // ShowButtons(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchasePrice]);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex justify-content-center text-left pt-1"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "p-0 d-flex justify-content-center"
  }, "Purchase Price")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Col,
    lg: 6
  }, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    ref: myRefPurchase,
    className: "form-control",
    placeholder: "Purchase Price",
    value: purchasePrice,
    displayType: "input",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false,
    onValueChange: values => {
      setPurchasePrice(values.value);
      dispatch((0, _actions.PurchasePriceUpdate)(values.value));
      // PurchasePriceUpdate(values.value);
    }
  })));
}